const DEFAULT_WIDTH = 512;
const DEFAULT_HEIGHT = 350;
const DEFAULT_BORDER_WIDTH = 2;
const DEFAULT_BORDER_COLOR = '#FFF';

export { DEFAULT_BORDER_COLOR, DEFAULT_BORDER_WIDTH, DEFAULT_HEIGHT, DEFAULT_WIDTH };
